declare global {
  interface Window {
    getCkyConsent?: () => ICkyConsent;
  }
}

export interface ICkyCategories {
  advertisement: boolean;
  analytics: boolean;
  functional: boolean;
  necessary: boolean;
  other: boolean;
  performance: boolean;
}

interface ICkyConsent {
  activeLaw: "gdpr" | "ccpa" | string;
  categories: ICkyCategories;
  consentID: string;
  isUserActionCompleted: boolean;
  languageCode: string;
}

let consentPromise: Promise<ICkyConsent> | null = null;
const CKY_TIMEOUT = 3000;

export const getConsent = () => {
  if (window.getCkyConsent) {
    return window.getCkyConsent();
  }

  if (consentPromise !== null) {
    return consentPromise;
  }

  consentPromise = new Promise(resolve => {
    let timeoutID: number | undefined = undefined;

    document.addEventListener("cookieyes_banner_load", function (eventData) {
      window.clearTimeout(timeoutID);
      const consent = (eventData as CustomEvent<ICkyConsent>).detail;
      resolve(consent);
    });

    timeoutID = window.setTimeout(() => {
      resolve({
        activeLaw: "gdpr",
        categories: {
          advertisement: false,
          analytics: false,
          functional: false,
          necessary: true,
          other: false,
          performance: false,
        },
        consentID: "",
        isUserActionCompleted: false,
        languageCode: "en",
      });
    }, CKY_TIMEOUT);
  });

  return consentPromise;
};
